export const captureUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmData = {
    utm_source: params.get("utm_source"),
    utm_medium: params.get("utm_medium"),
    utm_campaign: params.get("utm_campaign"),
    utm_content: params.get("utm_content"),
    utm_term: params.get("utm_term"),
    captured_at: new Date().toISOString(),
  };
  // Only store if UTM params are present
  if (utmData.utm_source) {
    localStorage.setItem("mmp_utm_params", JSON.stringify(utmData));
  }
};
export const getStoredUTMParams = () => {
  const stored = localStorage.getItem("mmp_utm_params");
  return stored ? JSON.parse(stored) : null;
};
export const clearUTMParams = () => {
  localStorage.removeItem("mmp_utm_params");
};
